Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeSwitcherReducer = void 0;

exports.themeSwitcherReducer = function (state, action) {
  switch (action.type) {
    case 'SET_ACTIVE_THEME':
      return Object.assign(Object.assign({}, state), {
        lastThemeId: undefined,
        activeThemeId: action.themeId
      });

    case 'SET_TEMPORARY_ACTIVE_THEME':
      return Object.assign(Object.assign({}, state), {
        lastThemeId: state.activeThemeId,
        activeThemeId: action.themeId
      });

    case 'SET_LAST_THEME':
      return Object.assign(Object.assign({}, state), {
        activeThemeId: state.lastThemeId ? state.lastThemeId : state.activeThemeId
      });

    default:
      throw new Error();
  }
};